// Module
var code = "<form class=\"ndd-ng-form-internal\" [ngClass]=\"{ 'ndd-ng-form-internal--row': controlOrientation === 'row', 'ndd-ng-form-internal--column': controlOrientation === 'column' }\" [id]=\"controlId\" [formGroup]=\"controlForm\" [attr.autocomplete]=\"controlAutocomplete\" novalidate> <ng-content></ng-content> </form> ";
// Exports
module.exports = code;